import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import type { BrandFilter } from "@/marketing/models/brand";
import { brandAPIClient } from "../brandAPIClient";
import { BRAND_KEYS } from "./keys";

export const BRAND_QUERIES = {
  list: (filter: BrandFilter = {}) =>
    queryOptions({
      queryKey: BRAND_KEYS.list(filter),
      queryFn: () => brandAPIClient.listBrands(filter),
      placeholderData: keepPreviousData,
      staleTime: 30_000,
    }),
  detail: (brandId: string) =>
    queryOptions({
      queryKey: BRAND_KEYS.detail(brandId),
      queryFn: () => brandAPIClient.getBrand(brandId),
      staleTime: 60_000,
      enabled: brandId !== "",
    }),
};
